import { Layout, Typography, Row, Col, Divider } from 'antd';
import { 
  FacebookOutlined, 
  TwitterOutlined, 
  InstagramOutlined, 
  LinkedinOutlined, 
  YoutubeOutlined,
  MailOutlined,
  HeartFilled
} from '@ant-design/icons';

const { Footer } = Layout;
const { Text, Link, Title } = Typography;

const AppFooter = () => {
  return (
    <Footer style={{ 
      background: 'linear-gradient(135deg, #0d306d 0%, #1a4fa0 100%)',
      color: '#fff',
      padding: '60px 24px 20px',
      boxShadow: '0 -4px 12px rgba(0, 0, 0, 0.1)'
    }}>
      <div style={{ 
        maxWidth: '1200px', 
        margin: '0 auto',
      }}>
        {/* Main footer content with side-by-side layout */}
        <Row gutter={[32, 32]} style={{ marginBottom: '40px' }}>
          {/* Logo and brand section - now on the left side */}
          <Col xs={24} md={8}>
            <div style={{ marginBottom: '16px' }}>
              <img
                src="/images/logo2.png"
                alt="SellSmart Logo"
                style={{
                  height: '42px',
                  width: 'auto',
                  verticalAlign: 'middle',
                  marginRight: '12px',
                  filter: 'brightness(0) invert(1)'
                }}
              />
              <span style={{
                fontSize: '24px',
                fontWeight: 700,
                color: '#fff',
                verticalAlign: 'middle'
              }}>
                SellSmart
              </span>
            </div>
            
            <Text style={{ 
              display: 'block',
              color: 'rgba(255, 255, 255, 0.8)',
              marginBottom: '20px',
              fontSize: '16px',
              lineHeight: '1.6'
            }}>
              The complete retail management solution designed for businesses. Streamline operations, boost sales, and gain real-time insights.
            </Text>
            
            {/* Social media icons */}
            <div style={{ display: 'flex', gap: '16px' }}>
              {/* <Link 
                href="#" 
                className="social-icon"
              >
                <FacebookOutlined style={{ fontSize: '20px' }} />
              </Link>
              <Link 
                href="#" 
                className="social-icon"
              >
                <TwitterOutlined style={{ fontSize: '20px' }} />
              </Link> */}
      <Link 
  href="https://www.instagram.com/sellsmart_pos?igsh=MTlsY3k2bzc1cWVwaA==" 
  target="_blank"
  rel="noopener noreferrer"
  className="social-icon"
>
                <InstagramOutlined style={{ fontSize: '20px' }} />
              </Link>
              {/* <Link 
                href="#" 
                className="social-icon"
              >
                <LinkedinOutlined style={{ fontSize: '20px' }} />
              </Link>
              <Link 
                href="#" 
                className="social-icon"
              >
                <YoutubeOutlined style={{ fontSize: '20px' }} />
              </Link> */}
            </div>
          </Col>
          
          {/* Quick Links */}
          <Col xs={24} sm={12} md={5}>
            <Title level={4} style={{ color: '#fff', marginBottom: '20px', fontSize: '18px' }}>
              Quick Links
            </Title>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <Link 
                href="#" 
                className="footer-link"
              >
                Home
              </Link>
              <Link 
                href="#" 
                className="footer-link"
              >
                Features
              </Link>
              <Link 
                href="#" 
                className="footer-link"
              >
                Pricing
              </Link>
              <Link 
                href="#" 
                className="footer-link"
              >
                About Us
              </Link>
              <Link 
                href="#" 
                className="footer-link"
              >
                Contact
              </Link>
            </div>
          </Col>
          
          {/* Resources */}
          <Col xs={24} sm={12} md={5}>
            <Title level={4} style={{ color: '#fff', marginBottom: '20px', fontSize: '18px' }}>
              Resources
            </Title>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <Link 
                href="#" 
                className="footer-link"
              >
                Documentation
              </Link>
              <Link 
                href="#" 
                className="footer-link"
              >
                Help Center
              </Link>
              <Link 
                href="#" 
                className="footer-link"
              >
                Community
              </Link>
              <Link 
                href="#" 
                className="footer-link"
              >
                Blog
              </Link>
              <Link 
                href="#" 
                className="footer-link"
              >
                FAQs
              </Link>
            </div>
          </Col>
          
          {/* Contact Information */}
          <Col xs={24} sm={12} md={6}>
            <Title level={4} style={{ color: '#fff', marginBottom: '20px', fontSize: '18px' }}>
              Contact Us
            </Title>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <div style={{ 
                display: 'flex', 
                alignItems: 'center', 
                marginBottom: '16px',
                color: 'rgba(255, 255, 255, 0.8)'
              }}>
                <MailOutlined style={{ marginRight: '10px', fontSize: '16px' }} />
                <Link 
                  href="mailto:support@sellsmart.com" 
                  className="footer-link"
                >
                  support@sellsmart.co.tz
                </Link>
              </div>
              {/* <Text style={{ color: 'rgba(255, 255, 255, 0.8)', lineHeight: '1.6', marginBottom: '16px' }}>
                123 Business Avenue, Suite 456<br />
                Tech City, TC 78901
              </Text> */}
              <Text style={{ color: 'rgba(255, 255, 255, 0.8)' }}>
                +255 (782) 913-983
              </Text>
            </div>
          </Col>
        </Row>
        
        <Divider style={{ borderColor: 'rgba(255, 255, 255, 0.2)', margin: '30px 0' }} />
        
        {/* Bottom section with copyright and developer info */}
        <Row align="middle" justify="space-between">
          <Col xs={24} md={12} style={{ marginBottom: '16px' }}>
            <Text style={{ color: 'rgba(255, 255, 255, 0.6)', display: 'block' }}>
              © {new Date().getFullYear()} SellSmart. All rights reserved.
            </Text>
            <Text style={{ color: 'rgba(255, 255, 255, 0.6)', display: 'block', marginTop: '4px' }}>
              Developed by Jcodes Technologies
            </Text>
          </Col>
          
          <Col xs={24} md={12} style={{ textAlign: 'right', marginBottom: '16px' }}>
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '16px' }}>
              <Link href="#" style={{ color: 'rgba(255, 255, 255, 0.6)' }} className="footer-bottom-link">
                Privacy Policy
              </Link>
              <Link href="#" style={{ color: 'rgba(255, 255, 255, 0.6)' }} className="footer-bottom-link">
                Terms of Service
              </Link>
              <Link href="#" style={{ color: 'rgba(255, 255, 255, 0.6)' }} className="footer-bottom-link">
                Cookie Policy
              </Link>
            </div>
          </Col>
        </Row>
      </div>
      
      {/* Inline styles for hover effects */}
      <style>
        {`
          .footer-link {
            color: rgba(255, 255, 255, 0.8) !important;
            margin-bottom: 12px;
            transition: all 0.3s ease;
            padding: 4px 0;
            display: block;
          }
          
          .footer-link:hover {
            color: #fff !important;
            transform: translateX(5px);
          }
          
          .social-icon {
            color: rgba(255, 255, 255, 0.8) !important;
            transition: all 0.3s ease;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 40px;
            height: 40px;
            border-radius: 50%;
            background: rgba(255, 255, 255, 0.1);
          }
          
          .social-icon:hover {
            color: #fff !important;
            background: rgba(255, 255, 255, 0.2);
            transform: translateY(-3px);
          }
          
          .footer-bottom-link {
            transition: all 0.3s ease;
          }
          
          .footer-bottom-link:hover {
            color: #fff !important;
          }
        `}
      </style>
    </Footer>
  );
};

export default AppFooter;